import type { Components } from 'react-markdown'
import Markdown from 'react-markdown'
import rehypeSanitize from 'rehype-sanitize'

interface WidgetMarkdownProps {
  content: string
  className?: string
  components?: Components
}

export const WidgetMarkdown: React.FC<WidgetMarkdownProps> = ({ content, className, components }) => {
  const allowedElementsSchema = { tagNames: ['a', 'button'] } // リンクとボタンのみ許可

  return (
    <Markdown
      className={className}
      rehypePlugins={[[rehypeSanitize, allowedElementsSchema]]}
      components={components}
    >
      {content}
    </Markdown>
  )
}
